<template>
    <el-drawer title="修改记录" :visible.sync="drawerShow" :wrapperClosable="false" :destroy-on-close="true" size="auto"
        append-to-body @close="close">
        <div class="drawer-content" v-loading="listLoading">
            <div class="page-list-box">
                <el-table :data="dataList" border style="width: 100%" v-loading="listLoading" size="small" stripe>
                    <el-table-column prop="createTime" label="修改时间" min-width="160"></el-table-column>
                    <el-table-column prop="createUserName" label="修改人" min-width="100" show-overflow-tooltip></el-table-column>
                    <el-table-column prop="preStatus" label="修改前状态" min-width="90">
                        <template slot-scope="{row} = scope">
                            {{status[row.preStatus]}}
                        </template>
                    </el-table-column>
                    <el-table-column prop="content" label="修改内容" min-width="200" show-overflow-tooltip></el-table-column>
                </el-table>
            </div>
            <div v-if="data" class="page-pagination-box">
                <el-pagination background @size-change="handleSizeChange" @current-change="getDataList"
                    :current-page.sync="params.pageNo" :page-sizes="$pageSizes" :page-size.sync="params.pageSize"
                    layout="total, sizes, prev, pager, next" :total="data.totalCount || 0">
                </el-pagination>
            </div>
        </div>
        <div class="drawer-footer">
            <el-button @click="close">关闭</el-button>
        </div>
    </el-drawer>
</template>
<script>
const defaultParams = {
    pageNo: 1,
    id: ""
}

export default {
    data(){
        return{
            drawerShow: false,
            data: null,
            dataList: null,
            params: {
                ...defaultParams,
                pageSize: this.$pageSizes[0],
            },
            listLoading: true,
        }
    },
    computed: {
        status() {
            return {
                1: '进行中', 2: '暂停中', 3: '已结束'
            }
        }
    },
    methods: {
        close() {
            this.drawerShow = false;
            this.params = {
                ...defaultParams,
                pageSize: this.$pageSizes[0]
            }
        },
        show(id) {
            this.params.id = id;
            this.getDataList();
            this.drawerShow = true;
        },
        //获取列表
        getDataList() {
            this.listLoading = true;
            this.$request({
                url: "/activity/cps/updateLog",
                method: "POST",
                params: {
                    ...this.params
                },
            })
                .then((res) => {
                    const { state, msg, result } = res.data;
                    if (state == 1 && result) {
                        this.data = result;
                        this.dataList = result.result || [];
                    } else {
                        this.$message.error(msg || "请求失败");
                    }
                })
                .catch(() => {
                    this.$message.error("请求错误");
                })
                .finally(() => {
                    this.listLoading = false;
                });
        },
        //选择pageSize
        handleSizeChange(e) {
            this.params.pageNo = 1;
            this.params.pageSize = e;
            this.getDataList();
        },
    }
}
</script>

<style lang="scss" scoped>

</style>